// src/setupDynamicHead.ts
export function setupDynamicHead() {
  const env = (window)._env_ || {};

  // ——— Update Title ———
  if (env.SITE_TITLE) {
    document.title = env.SITE_TITLE;
  }

  // ——— Update Favicon ———
  if (env.FAVICON_PATH) {
    const existing = document.querySelector('link[rel="icon"]');
    const faviconLink = existing || document.createElement("link");

    faviconLink.setAttribute("rel", "icon");
    faviconLink.setAttribute("type", "image/png");
    faviconLink.setAttribute("href", env.FAVICON_PATH);

    if (!existing) {
      document.head.appendChild(faviconLink);
    }
  }
}
